import ForecastInfoItem, { InfoItemStyles } from '@/components/ForecastInfoItem';
import GMField, { GMFieldStyles } from '@/components/GMField';
import { QuarteredForecast } from '@/models/QuarteredForecast';
import TWater from '@/public/assets/forecast-info-icons/twater.svg';

type ExtraDayInfoProps = Pick<QuarteredForecast, 'magneticField' | 'waterTemperature'>;

const ExtraDayInfo = ({ magneticField, waterTemperature }: ExtraDayInfoProps) => (
  <div className="pt-3 lg:flex lg:items-baseline lg:border-t lg:border-dashed lg:border-blue-grey-200">
    <GMField gmData={magneticField} styleType={GMFieldStyles.DAYS} className="mb-2 lg:mb-0 lg:mr-10" />
    {waterTemperature !== undefined && (
      <div className="flex items-center">
        <span className="hidden text-sm font-medium text-blue-grey-500 lg:mr-2.5 lg:inline">Температура воды</span>
        <ForecastInfoItem icon={<TWater className="h-[10px] w-[23px] lg:hidden" />} styleType={InfoItemStyles.DAYS}>
          <span>{waterTemperature}&deg;</span>
        </ForecastInfoItem>
      </div>
    )}
  </div>
);

export default ExtraDayInfo;
